import { useEffect, useRef } from 'react';

const useTimeout = (callback: () => void, delay: any) => {
  const savedCallback = useRef(callback);

  // Remember the latest callback if it changes.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the timeout.
  useEffect(() => {
    let id: any;
    // Don't schedule if no delay is specified.
    if (delay !== null) {
      id = setTimeout(() => savedCallback.current(), delay);
    }

    return () => clearTimeout(id);
  }, [delay]);
};

export default useTimeout;
